<div class="pb-[40px]">
  <div
    class="flex justify-between items-center w-full px-[50px] !pt-[23px] !pb-[0.6rem]"
  >
    <!-- Header on the left -->
    <div class="header h-[55px] flex items-center pl-[8px]">
      <p class="!m-0">{{ projectName }} - Initiate Expression of Interest</p>
    </div>

    <!-- Buttons on the right-->
    <div class="flex items-center space-x-2">
      <div class="container-fluid !pr-[0px]  bg-[#ffffff]">
        <div class="relative">
          <div class="rounded flex justify-end">
            <button
              *ngIf="isCreator"
              type="button"
              (click)="sendInvitations()"
              class="btn !mr-0"
              [ngClass]="
                submittedInitiation?.is_initiated === 1 ||
                (submittedInitiation?.is_initiated === 0 &&
                  approvalsStatus !== 'approved')
                  ? '!bg-[#868E96] !border-none'
                  : ''
              "
              [disabled]="
                submittedInitiation?.is_initiated === 1 ||
                approvalsStatus === 'pending'
                  ? true
                  : false
              "
              (mouseenter)="tooltipVisibilityToggle()"
              (mouseleave)="tooltipVisibilityToggle()"
            >
              {{ !submittedInitiation?.is_initiated ? 'Initiate' : 'Initiated' }}
            </button>
          </div>
      
          <div
          class="flex justify-end relative"
          *ngIf="showTooltip && approvalsStatus === 'pending'"
        >
          <app-custom-tooltip
            [toolTipMessage]="toolTipMessage?.INITIATE_DISABLE"
          ></app-custom-tooltip>
        </div>
        </div>
      </div>
      
      <button (click)="handleClose()" type="button" class="close-btn">
        Close
      </button>
      <button
        *ngIf="isCreator && !submittedInitiation?.is_initiated"
        (click)="handleEdit(eoiId)"
        type="button"
        class="edit-btn btn-primary cursor-pointer"
      >
        Edit
      </button>

      <button
        *ngIf="isCreator"
        (click)="handleApprovals()"
        [ngClass]="approvalsStatus === 'approved' ? '!bg-[#197741] !border-[#197741]' : approvalsStatus === 'rejected' 
        ? '!bg-[#ff0000] !border-[#ff0000]' 
        : '' "
        type="button"
        class="btn"
      >
        {{ approvalResponses ? "Approval Status" : "Send For Approvals" }}
      </button>
      <button
        *ngIf="
          !checkApprove &&
          internalApproval?.internal_approvals !== null &&
          isInApprovers
        "
        (click)="approvalResponseView(eoiId, projectId)"
        type="button"
        class="btn"
      >
        Approval Requested
      </button>
      <button
        *ngIf="checkApprove && isInApprovers"
        (click)="handleApprovals()"
[ngClass]="approvalsStatus === 'approved' ? '!bg-[#197741] !border-[#197741]' : '' "
        type="button"
        class="btn cursor-pointer"
      >
        Approval Sent
      </button>
    </div>
  </div>

  <div
    class="header h-[55px] flex justify-start items-center mx-[50px] pl-[14px] bg-[#F1F3F5]"
  >
    <p class="!m-0">Receiver Organization Details</p>
  </div>
  <div class="mx-[50px] mt-[1.5rem]">
    <div
      class="!mb-[1.5rem] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4"
    >
      <div
        class="!w-[100%] flex"
        style="
          max-height: calc(40vh - 141px);
          overflow-y: auto;
          border: 1px solid #ddd;
        "
      >
        <table class="!w-[100%] bg-[#fcfcfd] table-auto">
          <thead
            class="h-[52px] !bg-[#DEE2E6] text-[#000000] !text-left justify-left !pl-0 !p-[20px] sticky top-0 !z-20"
          >
            <tr>
              <th class="px-4 py-2 text-left">Company</th>
              <!-- <th class="px-4 py-2 text-left">Organization User Email</th> -->
              <th class="px-4 py-2 text-left">Name</th>

              <th class="px-4 py-2 text-left">User Email</th>
              <th class="px-4 py-2 text-left">Position</th>
              <th class="px-4 py-2 text-left">Status</th>
            </tr>
          </thead>
          <tbody style="margin-right: 0px; overflow-y: auto">
            <ng-container
              *ngFor="let orgDetail of enrichedOrganizations; let i = index"
            >
              <tr
                class="!h-[57px] hover:bg-[#ffefe9] border-b-0 items-center justify-center cursor-pointer"
                [ngClass]="{
                  'bg-white': i % 2 === 0,
                  'bg-[#DEE2E6]': i % 2 !== 0
                }"
                (click)="
                  openIndividualEOIResponsePreview(
                    orgDetail?.response?.id,
                    submittedInitiation?.project_id
                  )
                "
              >
                <td class="border-b-0 px-4 py-2 text-left">
                  <span
                  [title]="orgDetail?.applicant_organization?.email"
                >
                  {{
                    orgDetail?.receiving_org_id
                      ? orgDetail?.applicant_organization?.name
                      : orgDetail?.external_company_name
                  }}
                </span>
                </td>
                <!-- <td class="border-b-0 px-4 py-2 text-left">
                  {{ orgDetail?.applicant_organization?.email }}
                </td> -->
                <td class="border-b-0 px-4 py-2 text-left">
                  {{ orgDetail?.name }}
                </td>

                <td class="border-b-0 px-4 py-2 text-left">
                  {{ orgDetail?.email }}
                </td>
                <td class="border-b-0 px-4 py-2 text-left">
                  {{ orgDetail?.position }}
                </td>
                <td class="border-b-0 text-left">
                  <span
                    [ngClass]="{
                      'status-received':
                        orgDetail?.response?.status === 'Received',
                      'status-pending':
                        orgDetail?.response?.status === 'pending',
                        'status-submitted':
                        orgDetail?.response?.status === 'submitted',

                    }"
                  >
                  {{ orgDetail?.response?.status | titlecase }}
                  </span>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </div>

    <div
      class="header h-[55px] flex justify-start items-center pl-[14px] mt-[30px] bg-[#F1F3F5]"
    >
      <p class="!m-0">Receiver Side Preview</p>
    </div>
    <div
      class="header flex justify-start items-center pl-[14px] mt-[11px]"
    >
      <p class="!m-0">Project Brief</p>
    </div>
    <div class="w-[100%] pb-[30px] pt-[0px]">
      <app-brief-section></app-brief-section>
      <div
        class="header h-[55px] flex justify-start items-center pl-[14px] mt-[0.4rem] mb-[18px] bg-[#F1F3F5]"
      >
        <p class="!m-0">Selected Work Packages</p>
      </div>

      <div class="w-[50%] mt-[7px] ml-[14px]">
        <div
          *ngFor="
            let orgDetail of submittedInitiation?.selected_work_packages;
            let i = index
          "
          class="w-[100%] !h-[49px] flex justify-between items-center"
        >
          <div class="flex justify-start">
            <img
              src="assets/icons/checkbox.png"
              class="h-[20px] w-[20px] mr-[12px]"
              alt="checkbox"
            />
            <p class="packages-name">{{ orgDetail?.name }}</p>
          </div>
        </div>
      </div>

      <div
        class="header h-[55px] flex justify-start items-center pl-[14px] mt-[0.4rem] mb-[18px] bg-[#F1F3F5]"
      >
        <p class="!m-0">Eligibility Criteria</p>
      </div>
      <div class="w-[100%] mt-[7px] ml-[12px]">
        <div class="w-[100%] flex justify-between items-center">
          <div class="flex justify-start">
            <p
              class="breif-value"
              [innerHTML]="
                getSanitizedHtml(submittedInitiation?.eligibility_criteria)
              "
            ></p>
          </div>
        </div>
      </div>

      <div
        class="header h-[55px] flex justify-start items-center pl-[14px] mt-[0.4rem] mb-[18px] bg-[#F1F3F5]"
      >
        <p class="!m-0">Submission Guideline</p>
      </div>
      <div
        class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4 pl-[14px]"
      >
        <div class="items-center">
          <label for="issueOfEOI" class="attribute-header w-[140px]"
            >Issue of EOI</label
          >
          <input
            id="issueOfEOI"
            class="mt-1 p-2 block !w-[494.5px] section-input sm:text-sm"
            [value]="submittedInitiation?.issue_date"
            readonly
          />
        </div>
        <div class="items-center">
          <label for="eoiSubmissionClosing" class="attribute-header w-[140px]"
            >EOI Submission Closing</label
          >
          <input
            id="eoiSubmissionClosing"
            class="mt-1 p-2 block !w-[494.5px] section-input sm:text-sm"
            [value]="submittedInitiation?.submission_date"
            readonly
          />
        </div>
        <div class="items-center">
          <label for="eoiInquiryDeadline" class="attribute-header w-[140px]"
            >EOI Inquiry Deadline</label
          >
          <input
            id="eoiInquiryDeadline"
            class="mt-1 p-2 block !w-[494.5px] section-input sm:text-sm"
            [value]="submittedInitiation?.inquiry_deadline"
            readonly
          />
        </div>
        <div class="items-center">
          <label for="floatEPCTender" class="attribute-header w-[140px]"
            >Float EPC Tender</label
          >
          <input
            id="floatEPCTender"
            class="mt-1 p-2 block !w-[494.5px] section-input sm:text-sm"
            [value]="submittedInitiation?.epc_date"
            readonly
          />
        </div>
      </div>

      <p class="intro flex justify-start !mt-[2rem] !mb-0 pl-[10px]">
        Clarification & Communication
      </p>
      <p class="breif-value pl-[10px]">
        For Inquires regarding this EOI, applicants should contact the
        designated representatives via email. All communication will be done in
        writing, and a log of all queries and responses will be maintained.
      </p>

      <p class="intro flex justify-start !mt-[29px] !mb-0 pl-[10px]">
        Confidentiality
      </p>
      <p class="breif-value pl-[10px]">
        All information provided in response to this EOI will be treated as
        confidential.
      </p>
    </div>
    <div
    class="header h-[55px] flex justify-start items-center mb-[18px] bg-[#F1F3F5]"
  >
    <p class="!m-0 pl-[10px] !pr-[30px]">Show Templates</p>
    <button (click)="toggle()" 
    class="flex items-center justify-center toggleButton p-2">
    
    <div class="w-12 h-6 pr-[5px] bg-gray-300 rounded-full relative toggle-button"
         [class.active]="showTemplateForm">
         
        <div class="w-6 h-6 bg-white rounded-full absolute transition-all duration-300"
             [class.translate-x-6]="showTemplateForm">
        </div>
        </div>

      </button>
  </div>
   <div  *ngIf="showTemplateForm">
    <div
      class="header h-[55px] flex justify-start items-center mb-[18px] bg-[#F1F3F5]"
    >
      <p class="!m-0 pl-[10px] !pr-[30px]">EOI Form</p>
    </div>
    <div class="w-[100%] mt-[15px] pt-[13px] pl-[10px]">
      <app-eoi-read-only></app-eoi-read-only>

      <p class="intro flex justify-start !mb-0 pl-[3px]">Disclaimer</p>
      <p class="breif-value pl-[3px]">
        This Expression of Interest (EOI) document has been prepared by OQ
        Alternative Energy solely for the benefit of OQ Alternative Energy. This
        document contains confidential and legally privileged information and
        may not be disclosed to, or relied upon by, any person or entity other
        than OQ Alternative Energy without the prior written consent of OQ
        Alternative Energy. Any recipient of this document is required to treat
        it as confidential and may not disclose it to any third parties other
        than its technical, financial, insurance, tax, and accounting teams, and
        only to the extent that: (i) such disclosure is necessary for the
        purpose of responding to this EOI; (ii) the recipient makes these
        parties aware of the confidential nature of this information; (iii) the
        receiving parties are subject to professional or legal obligations to
        maintain the confidentiality of such information. OQ Alternative Energy
        does not assume any duty or responsibility to any person or entity with
        respect to the information contained in this EOI, whether in contract,
        tort, statute, or otherwise, including negligence. Recipients of this
        document shall not rely upon the information for any purpose other than
        the submission of an expression of interest as described in this
        document.
      </p>
    </div>

    <div class="container-fluid p-[29px] !pr-[0px] !mt-[5px] bg-[#ffffff]">
      <!-- <div class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4">
        <div
          class="rounded flex justify-end"
          (mouseenter)="tooltipVisibilityToggle()"
          (mouseleave)="tooltipVisibilityToggle()"
        >
          <button
            *ngIf="isCreator"
            type="button"
            (click)="sendInvitations()"
            class="btn"
            [ngClass]="
              submittedInitiation?.is_initiated === 1 ||
              (submittedInitiation?.is_initiated === 0 &&
                approvalsStatus !== 'approved')
                ? '!bg-[#868E96] !border-none'
                : ''
            "
            [disabled]="
              submittedInitiation?.is_initiated === 1 ||
              approvalsStatus === 'pending'
                ? true
                : false
            "
          >
            {{ !submittedInitiation?.is_initiated ? "Initiate" : "Initiated" }}
          </button>
        </div>
      </div>
      <div
        class="flex justify-end !mb-[30px]"
        *ngIf="showTooltip && approvalsStatus === 'pending'"
      >
        <app-custom-tooltip
          [toolTipMessage]="toolTipMessage?.INITIATE_DISABLE"
        ></app-custom-tooltip>
      </div> -->
    </div>
  </div>
  </div>
</div>

<ng-container *ngIf="isEdit">
  <app-wrapper
    (handleDialog)="handleDialog()"
    [currentDialog]="currentDialog"
    [currentEOISavedData]="savedEOIData"
  ></app-wrapper>
</ng-container>
